<template>
    <div>
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Table ref="selection" :data="data" :columns="columns"></Table>
        <Page :current="currentPage" :total="dataCount" :page-size="pageSize" show-sizer show-total @on-change="changePage"
            @on-page-size-change="changePageSize"></Page>
    </div>
</template>
<script>
    export default {
        props: {
            isPc: ""
        },
        mounted(){
            //查询表具信息
            if (this.isSpinShow == false) {
                this.isSpinShow = true;
            }
            var that = this;
            that.$parent.isSpinShow = true;
            $.ajax({
                url: "/api/getMeterInfoForProduce?page=" +
                    this.currentPage +
                    "&pageAmount=" +
                    this.pageSize,
                contentType: "application/json",
                type: "post",
                data: JSON.stringify(that.viewMeterDetailed),
                dataType: "json",
                success: function(receiveData) {
                    if (receiveData.errorCode == 0) {
                        that.totalData = receiveData.body.resultList;
                        that.dataTotalCount = receiveData.body.amount;
                    } else {
                        that.$Notice.error({
                            title: "异常",
                            desc: receiveData.errorInfo
                        });
                    }
                    that.$parent.isSpinShow = false;
                    that.isSpinShow = false;
                },
                error: function(textStatus) {
                    that.isSpinShow = false;
                    that.$Notice.error({
                        title: "异常",
                        desc: "接口请求异常"
                    });
                }
            });
        },
        data() {
            return {
                // 初始化信息总条数
                dataCount: 0,
                // 每页显示多少条
                pageSize: 10,
                // 初始第一页
                currentPage: 1,
                // 遮罩
                selectIndex: -1,
                isSpinShow: false,
                viewMeterDetailed: {},
                viewMeterDetailedResult: {},
                dataSelected: {},
                data: [],
                totalData: [],
                dataTotalCount: 0,
                columns: [{
                        title: " ",
                        width: 60,
                        key: "checkBox",
                        render: (h, params) => {
                            return h("Checkbox", {
                                props: {
                                    value: params.row.checkBox
                                },
                                on: {
                                    "on-change": val => {
                                        this.data.forEach(items => {
                                            //先取消所有对象的勾选，checkBox设置为false
                                            this.$set(items, "checkBox", false);
                                        });
                                        this.data[params.index].checkBox = val;
                                        if (val) {
                                            this.selectIndex = params.index;
                                            console.log(this.data[this.selectIndex]);
                                            this.$emit(
                                                "listenToChild2EventForMeterId",
                                                this.data[this.selectIndex]
                                            );
                                        } else {
                                            this.selectIndex = -1;
                                        }
                                        this.$emit("listenToChild2EventForButton", this.selectIndex);
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: "设备编号",
                        key: "produceDeviceId"
                    },
                    {
                        title: "产品编号",
                        key: "produceId"
                    },
                    {
                        title: "设备类型",
                        key: "produceDeviceInfo"
                    }
                ]
            };
        },
        methods: {
            changePage(index) {
                this.currentPage = index;
                this.selectIndex = -1;
                this.$emit("listenToChild2EventForButton", this.selectIndex);
                this.getMeterList(this.viewMeterDetailed);
            },
            changePageSize(size) {
                this.pageSize = size;
                this.selectIndex = -1;
                this.$emit("listenToChild2EventForButton", this.selectIndex);
                this.getMeterList(this.viewMeterDetailed);
            },
            getMeterList(param) {
                //查询表具信息
                if (this.isSpinShow == false) {
                    this.isSpinShow = true;
                }
                this.selectIndex = -1;
                this.viewMeterDetailed = param;
                var that = this;
                that.data = [];
                that.dataCount = 0;
                that.totalData.map(item=>{
                    if (item.produceDeviceId.indexOf(param.meterId) != -1) {
                        that.data.push(item);
                    }
                });
                that.dataCount = that.data.length;
                that.data = that.data.filter((item, index)=>{
                    if (index >= (that.currentPage - 1) * that.pageSize
                        && index < that.currentPage * that.pageSize) {
                        return true;
                    } else {
                        return false;
                    }
                });
                that.isSpinShow = false;
            },
            showlog() {
                console.log(this.data[this.selectIndex]);
            }
        },
        created() {}
    };
</script>
<style>
    .spin-icon-load {
        animation: ani-spin 1s linear infinite;
    }

    @keyframes ani-spin {
        from {
            transform: rotate(0deg);
        }

        50% {
            transform: rotate(180deg);
        }

        to {
            transform: rotate(360deg);
        }
    }
</style>
